module.exports = __webpack_public_path__ + "img/2fb992fb817ab5c4c55cdaffe28384b5.png";